import React from "react";
import assetLocations from "assetLocations";

export type SupportedImageErrorCodes = 404;

interface IProps {
    code: SupportedImageErrorCodes;
}

export default function ErrorCodeTitle(props: IProps) {
    const { code } = props;

    return <img src={assetLocations.errorCodeTitles[code]} alt={`${code} Error`} />;
}
